import React from "react";

import { ReactComponent as HushSpelledSVG } from "src/images/svg/hush-single-letters.svg";

import "./hush-spelled.css";

export const HushSpelled = ({ className }: { className?: string }) => {
	return <HushSpelledSVG className={className} />;
};
